import { Subject } from 'rxjs'

export const projectsChangedTopic = new Subject();

export const publishProjectsChanged = () => projectsChangedTopic.next(undefined);
